import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiEndpoints } from '@firebird-web/shared-constants';
import { environment } from '@firebird-web/shared-config';
import { CustomListItem } from '../types/import-custom-list.types';
import { Observable } from 'rxjs';

@Injectable()
export class ImportCustomListsNetworkingService {
  constructor(private http: HttpClient) {}

  public getCustomLists(payload?: string): Observable<CustomListItem[]> {
    const endpointUrl =
      `${environment.apiDomain}/${apiEndpoints.getWSICustomLists}` +
      (payload ? `?profileName=${payload}` : '');
    return this.http.get<CustomListItem[]>(endpointUrl);
  }

  public importCustomLists(
    customListIds: string[],
    profile?: string
  ): Observable<void> {
    const endpointUrl =
      `${environment.apiDomain}/${apiEndpoints.importWSICustomLists}` +
      (profile ? `?profileName=${profile}` : '');
    return this.http.post<void>(endpointUrl, { customListIds });
  }
}
